import BillingHttp from '@/services/BillingHttp';

export default {
  namespaced: true,
  state: {
    plan: [],
  },
  getters: {
    hasCredits: (state) => {
      if (!state.plan.plan) {
        //postpaid subscription
        return true;
      }
      const { quota } = state.plan;
      return quota.envelopes.consumed < quota.envelopes.available;
    },
    isPostpaid: (state) => !state.plan.plan,
  },
  actions: {
    getSubscription: ({ commit }) =>
      BillingHttp.getSubscription().then((result) => {
        commit('setSubscription', result.data);
      }),
  },
  mutations: {
    setSubscription: (state, plan) => {
      state.plan = plan;
    },
  },
};
